var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "mb-24" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.brand.tableData,
              border: "",
              "header-cell-style": { background: "#EDF0F4", color: "#333" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "商标图案", prop: "tmPic", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.tmPic
                        ? _c("img", {
                            staticStyle: { "max-width": "60px" },
                            attrs: { src: scope.row.tmPic, alt: "" },
                          })
                        : _c("span", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "商标名称", prop: "tmName", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.tmName || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "商标状态", prop: "status", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.status || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "申请/注册号", prop: "regNo", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.regNo || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "申请日期", prop: "appDate", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(_vm._s(scope.row.appDate.slice(0, 10) || "--")),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "国际分类", prop: "intCls", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.intCls || "--"))]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c("pagination", {
              attrs: { pageNum: _vm.brand.pageNum, total: _vm.brand.total },
              on: {
                currentChange: function (val) {
                  return _vm.handleCurrentChange(val, 1)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "mb-24" },
      [
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.patent.tableData,
              border: "",
              "header-cell-style": { background: "#EDF0F4", color: "#333" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: { label: "专利类型", prop: "patentType", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.patentType || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "公开（公告）号",
                prop: "pubnumber",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.pubnumber || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "公开（公告）日期",
                prop: "pubDate",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.pubDate || "--"))]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "名称", prop: "title", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.title || "--"))]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c("pagination", {
              attrs: { pageNum: _vm.patent.pageNum, total: _vm.patent.total },
              on: {
                currentChange: function (val) {
                  return _vm.handleCurrentChange(val, 2)
                },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("商标信息")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("专利信息")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }